import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from 'wire-frame';

@Injectable({
  providedIn: 'root'
})
export class AdminInventoryService {

  constructor(private http: HttpClient, private common: CommonService) { }

  getAdminInventory(payload: (string | null) = null) {
    return this.http.get(
      this.common.getBaseUrl() + 'AdminInventory.php?action=AdminInventoryList' + (payload ? '&list=all' : '')
    );
  }

  addAdminInventory(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addAdminInventory";
    return this.http.post(this.common.getBaseUrl() + 'AdminInventory.php', payload);
  }

  updateAdminInventory(payload: any) {
    payload["action"] = "updateAdminInventory";
    return this.http.put(this.common.getBaseUrl() + 'AdminInventory.php', payload);
  }

  deleteAdminInventory(payload: any) {
    payload["action"] = "deleteAdminInventory";
    return this.http.put(this.common.getBaseUrl() + 'AdminInventory.php', payload);
  }

}
